import React from 'react';
import { Form, Select } from 'antd';
import { getClassNames } from '../../utils';
import { NotificationDeliveryType } from '../../enums/notification-delivery-type';
import { NotificationDeliveryWindow } from '../../enums/notification-delivery-window';
import titleCase from 'title-case';
import { FormLayoutRow } from '../form-layout-row/form-layout-row';
export var DomainDeliveryDisplay = function DomainDeliveryDisplay(_ref) {
  var defaults = _ref.defaults,
      entity = _ref.entity;
  var defaultDeliveryType = (defaults === null || defaults === void 0 ? void 0 : defaults.type) || NotificationDeliveryType.IMMEDIATE;
  var defaultDeliveryWindow = (defaults === null || defaults === void 0 ? void 0 : defaults.window) || NotificationDeliveryWindow.STANDARD;

  var normalizeForDisplay = function normalizeForDisplay(value) {
    var _entity$displayMeta, _entity$displayMeta2;

    var displayString = value;

    if (((_entity$displayMeta = entity.displayMeta) === null || _entity$displayMeta === void 0 ? void 0 : _entity$displayMeta.default_delivery_type) === NotificationDeliveryType.IMMEDIATE && displayString === NotificationDeliveryWindow.STANDARD) {
      displayString = 'NOW';
    }

    if (((_entity$displayMeta2 = entity.displayMeta) === null || _entity$displayMeta2 === void 0 ? void 0 : _entity$displayMeta2.default_delivery_type) === NotificationDeliveryType.SCHEDULED) {
      if (displayString === NotificationDeliveryWindow.TIMEZONE) {
        displayString = 'SUBSCRIBER TIME ZONE';
      }

      if (displayString === NotificationDeliveryWindow.STANDARD) {
        displayString = 'FIXED';
      }
    }

    return displayString;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Default Delivery Type",
    value: titleCase(defaultDeliveryType)
  }), /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Default Delivery Strategy",
    value: defaultDeliveryWindow === NotificationDeliveryWindow.STANDARD ? defaultDeliveryType === NotificationDeliveryType.IMMEDIATE ? 'Now' : 'Fixed' : titleCase(normalizeForDisplay(defaultDeliveryWindow))
  }));
};
export var DomainDeliveryEditor = function DomainDeliveryEditor(_ref2) {
  var entity = _ref2.entity,
      form = _ref2.form;

  var buildConfigStrategyOptions = function buildConfigStrategyOptions(type) {
    var configOptions = [];

    if (type === NotificationDeliveryType.IMMEDIATE) {
      configOptions = [NotificationDeliveryWindow.STANDARD, NotificationDeliveryWindow.INFORMED];
    } else if (type === NotificationDeliveryType.SCHEDULED) {
      configOptions = [NotificationDeliveryWindow.STANDARD, NotificationDeliveryWindow.TIMEZONE, NotificationDeliveryWindow.INFORMED];
    }

    return configOptions;
  };

  var normalizeForDisplay = function normalizeForDisplay(value) {
    var displayString = value;

    if (form.getFieldValue('defaultDeliveryTypeValue') === NotificationDeliveryType.IMMEDIATE && displayString === NotificationDeliveryWindow.STANDARD) {
      displayString = 'NOW';
    } else if (form.getFieldValue('defaultDeliveryTypeValue') === NotificationDeliveryType.SCHEDULED) {
      if (displayString === NotificationDeliveryWindow.TIMEZONE) {
        displayString = 'SUBSCRIBER TIME ZONE';
      } else if (displayString === NotificationDeliveryWindow.STANDARD) {
        displayString = 'FIXED';
      }
    }

    return displayString;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassNames('ddf-delivery-editor')
  }, /*#__PURE__*/React.createElement(Form.Item, {
    label: "Delivery Type",
    name: "defaultDeliveryTypeValue"
  }, /*#__PURE__*/React.createElement(Select, {
    size: "middle",
    onChange: function onChange(type) {
      form.setFieldsValue({
        defaultDeliveryWindowValue: undefined,
        defaultDeliveryTypeValue: type
      });
    }
  }, /*#__PURE__*/React.createElement(Select.Option, {
    value: NotificationDeliveryType.IMMEDIATE
  }, titleCase(NotificationDeliveryType.IMMEDIATE)), /*#__PURE__*/React.createElement(Select.Option, {
    value: NotificationDeliveryType.SCHEDULED
  }, titleCase(NotificationDeliveryType.SCHEDULED)))), /*#__PURE__*/React.createElement(Form.Item, {
    shouldUpdate: function shouldUpdate(prevValues, newValues) {
      return prevValues.defaultDeliveryTypeValue !== newValues.defaultDeliveryTypeValue;
    },
    noStyle: true
  }, function (_ref3) {
    var _entity$displayMeta$d, _entity$displayMeta3;

    var getFieldValue = _ref3.getFieldValue;
    return /*#__PURE__*/React.createElement(Form.Item, {
      label: "Delivery Strategy",
      name: "defaultDeliveryWindowValue",
      rules: [{
        required: !!form.getFieldValue('defaultDeliveryTypeValue'),
        message: 'A default delivery strategy is required.'
      }]
    }, /*#__PURE__*/React.createElement(Select, {
      defaultValue: (_entity$displayMeta$d = entity === null || entity === void 0 ? void 0 : (_entity$displayMeta3 = entity.displayMeta) === null || _entity$displayMeta3 === void 0 ? void 0 : _entity$displayMeta3.default_delivery_window) !== null && _entity$displayMeta$d !== void 0 ? _entity$displayMeta$d : titleCase(normalizeForDisplay(NotificationDeliveryWindow.STANDARD)),
      size: "middle",
      options: buildConfigStrategyOptions(getFieldValue('defaultDeliveryTypeValue')).map(function (opt) {
        return {
          label: titleCase(normalizeForDisplay(opt)),
          value: opt
        };
      })
    }));
  }));
};